import React from 'react';

export const Arrow = () => {
    return (<>
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 8.5">
            <polyline className="cls-1" points="1.5 1.5 7 7 12.5 1.5"/>
        </svg>
    </>)
}